import BasePage from "../modules/basePage";
import Experience from "../modules/storybook/storybook";
import "../../css/pages/StorybookPage.scss";
class StorybookPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        Experience.initialize("experience-root");
    }

    onReady() {
        super.onReady();
    }
}

new StorybookPage();
